import React, { createContext, useContext, useState } from 'react';
import TournamentsSelectionsPopup from './tournaments-selections/TournamentsSelectionsPopup';

export const MAX_SELECTIONS = 15;

const TournamentsSelectionsContext = createContext();

export function useTournamentsSelections() {
    return useContext(TournamentsSelectionsContext);
}

export default function TournamentsSelectionsProvider(props) {
    const [showPopup, setShowPopup] = useState();
    const [selections, setSelections] = useState({
        ids: new Set(),
        sportId: null,
        toggleId: function(id) {
            if (!this.ids.has(id)) {
                if (this.ids.size === MAX_SELECTIONS) {
                    setShowPopup(true);
                    return;
                }
                this.ids.add(id);
            } else {
                this.ids.delete(id)
            }
            setSelections({
                ...selections
            });
        },
        reset: function() {
            this.ids.clear();
            setSelections({
                ...selections
            });
        }
    });

    return (
        <>
            {showPopup &&
                <TournamentsSelectionsPopup toggle={() => setShowPopup(prev => !prev)} />
            }
            <TournamentsSelectionsContext.Provider value={selections}>
                {props.children}
            </TournamentsSelectionsContext.Provider>
        </>
    );
}
